import { initBotId } from 'botid/client/core'

initBotId({
  protect: [
    {
      path: '/api/form-submissions',
      method: 'POST',
    },
  ],
})
